export default {
	'backColor': 'strBackColor',
	'bundleCount': 'intBundleCount',
	'logId': 'intLogId',
	'logNo': 'strLogNo',
	'speciesName': 'strSpecieName',
	'teaser': 'strPreviewImageURL',
	'logArea': 'decLogArea',
	'thicknessMm': 'decThicknessMm',
	'maxLength': 'intMaxLength',
	'customerQualityName': 'strCustomerQualityName',
	'structure': 'strStructure',
	'characteristic': 'strCharacteristic',
	'grade': 'decGrade',
	'place': 'strPlace',
	'palletNo': 'strPalletNo',
	'logInfo': 'strLogInfo',
	'palletInfo': 'strPalletInfo',
	'imageUrls': 'lstImageURLs',
	'internalQualityName': 'strInternalQualityName',
	'maxLogLength': 'intMaxLogLength',
	'previewImageType': 'intPreviewImageType',
	'previewImageURL': 'strPreviewImageURL',
	'specieGid': 'strSpecieGId',
	'specieName': 'strSpecieName'
}